"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ProgressCircular", {
    enumerable: true,
    get: function() {
        return ProgressCircular;
    }
});
var ProgressCircular = {
    baseStyle: {
        label: {
            color: "text-secondary",
            top: "50%",
            left: "50%",
            width: "100%",
            textAlign: "center",
            position: "absolute",
            transform: "translate(-50%, -50%)"
        },
        track: {
            backgroundColor: "background-static"
        },
        filledTrack: {
            backgroundColor: "primary-default"
        }
    },
    defaultProps: {
        size: "5rem"
    }
};
